module.exports = __webpack_public_path__ + "img/zlogo2.5255c78e.png";